<template>
    <ul>
        <li>
            <NuxtLink to="/about/privacy" :class="{active: currentLink === 'home'}">
                <VJoyIcon name="home" />
                <span>{{ $t('rgpd.aside.nav.link.home') }}</span>
            </NuxtLink>
        </li>
        <li>
            <NuxtLink to="/about/privacy/policy" :class="{active: currentLink === 'policy'}">
                <VJoyIcon name="file" />
                <span>{{ $t('rgpd.aside.nav.link.policy') }}</span>
            </NuxtLink>
        </li>
        <li>
            <a href="/about/privacy/cookies" :class="{active: currentLink === 'cookies'}">
                <VJoyIcon name="archive" />
                <span>{{ $t('rgpd.aside.nav.link.cookies') }}</span>
            </a>
        </li>
        <li>
            <NuxtLink to="/about/privacy/candidate-privacy-policy" :class="{active: currentLink === 'candidate-privacy-policy'}">
                <VJoyIcon name="legal-check" />
                <span>{{ $t('rgpd.aside.nav.link.data.protection.policy') }}</span>
            </NuxtLink>
        </li>
    </ul>
</template>
<script setup lang="ts">
    import {VJoyIcon} from '@maltjoy/core-vue';

    defineProps({
        currentLink: {
            type: String,
            required: true,
        },
    });
</script>
<style lang="scss" scoped>
    ul {
        list-style: none;
        padding: 0;
        margin: 0;
        li {
            margin-bottom: 1rem;
            .joy-icon {
                position: relative;
                top: 3px;
            }

            a {
                color: var(--joy-color-neutral-40);
                text-decoration: none;
                font-size: var(--joy-font-size-primary-400);
                display: flex;
                gap: var(--joy-core-spacing-2);

                &.active {
                    color: var(--joy-color-neutral-70);
                    font-weight: var(--joy-font-weight-bold);
                }

                &:hover {
                    color: var(--joy-color-neutral-70);
                }
            }
        }
    }
</style>
